import type { Route } from 'nextjs-routes';

// Public list/root pages that should appear in sitemap.xml and be crawlable.
export const INDEXABLE_STATIC_ROUTES: Array<Route['pathname']> = [
  '/',
  '/txs',
  '/blocks',
  '/tokens',
  '/token-transfers',
  '/ops',
  '/bundles',
  '/verified-contracts',
  '/signed-authorizations',
  '/stats',
  '/gas-tracker',
  '/apps',
  '/api-docs',
  '/name-domains',
  '/accounts',
  '/withdrawals',
  '/deposits',
  '/batches',
  '/pools',
  '/validators',
];

// Pages that should not be indexed (private, utility, or thin/duplicate surfaces).
export const NOINDEX_ROUTES: Array<Route['pathname']> = [
  '/login',
  '/sprite',
  '/auth/profile',
  '/account/rewards',
  '/account/watchlist',
  '/account/api-key',
  '/account/custom-abi',
  '/account/tag-address',
  '/account/verified-addresses',
  '/csv-export',
  '/developers/csv-export',
  '/search-results',
  '/public-tags/submit',
  '/visualize/sol2uml',
  '/advanced-filter',
  '/graphiql',
];
